import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import ContainerImages from "../components/HomeContainer/ContainerImages";
import Container from "../components/HomeContainer/Container";
import ContainerImages2 from "../components/HomeContainer/ContainerImages2";
import MobileBanner from "../components/MobileContainer/MobileBanner";
import AgHubHeader from "../components/Header/AgHubHeader";
import Footer from "../components/Footer/Footer";
export default function Home() {
  // Use media query to detect small screens
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down(899)); // Change 'sm' to your desired breakpoint
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        backgroundColor: "var(--Tokens-Background-Default, #F3F7FD);",
      }}
    >
      {/* Conditionally render layout X or layout Y */}
      {isSmallScreen ? (
        // Layout Y for small screens
        <Box data-testid="small-screen">
          <AgHubHeader />
          {/* Render your smaller screen layout here */}
          <Box>
            <MobileBanner />
          </Box>
          <Footer />
        </Box>
      ) : (
        // Layout X for larger screens
        <>
          <div className="w-full" data-testid="large-screen">
            <AgHubHeader />
          </div>
          {/* Top ContainerImages */}
          <Box>
            <ContainerImages />
          </Box>

          {/* Middle Container */}
          <Box
            sx={{
              paddingX: "5%",
              marginTop: "-5px", // Overlap above top images
              marginBottom: "-45px", // Overlap below to bottom images
              position: "relative",
              zIndex: 4, // Ensure this appears above the images
            }}
          >
            <Container />
          </Box>

          {/* Bottom ContainerImages2 */}
          <Box sx={{ marginTop: "30px" }}>
            <ContainerImages2 />
          </Box>
          <div className="w-full">
            <Footer />
          </div>
        </>
      )}
    </Box>
  );
}
